import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faLayerGroup, faPeopleGroup, faShapes } from '@fortawesome/free-solid-svg-icons';
import UserMenuContent from './UserMenuContent';
import { useEffect, useState } from 'react';

const HeaderMenu = ({ open, isAuthenticated, sandboxSignInUrl, lab, onOpenLabAccess, onOpenChange }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 760);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 760;
      if (isMobile && !newIsMobile && open) {
        onOpenChange(false);
      }
      setIsMobile(newIsMobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, open, onOpenChange]);

  return (
    <>
      <div className={`menu-container ${open ? 'active' : ''}`} id="menu">
        <a className="menu-item" href="/training">
          <FontAwesomeIcon icon={faBookOpen} className="menu-item-icon" /> Training
        </a>
        {/* Epic 17: the module catalogue (mod), by package and by category - the two tiles of
            mod's own landing page, which dev's design replaced. */}
        <a className="menu-item" href="/package">
          <FontAwesomeIcon icon={faLayerGroup} className="menu-item-icon" /> Packages
        </a>
        <a className="menu-item" href="/category">
          <FontAwesomeIcon icon={faShapes} className="menu-item-icon" /> Categories
        </a>
        <a className="menu-item" href="/consulting">
          <FontAwesomeIcon icon={faPeopleGroup} className="menu-item-icon" /> Consulting
        </a>
        {open && (
          <UserMenuContent
            isAuthenticated={isAuthenticated}
            sandboxSignInUrl={sandboxSignInUrl}
            lab={lab}
            onOpenLabAccess={onOpenLabAccess}
          />
        )}
      </div>
    </>
  );
};

export default HeaderMenu;
